import React from "react";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
  },
  {
    component: React.lazy(
      () => import("views/auth-views/authentication/register"),
    ),
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
  },
  {
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
  },
];

export const protectedRoutes = [
  {
    component: React.lazy(() => import("views/app-views/dashboards/default")),
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
  },
  {
    component: React.lazy(() => import("views/app-views/doctors/doctorsList")),
    key: "doctors",
    path: `${APP_PREFIX_PATH}/doctors`,
  },
  {
    component: React.lazy(() => import("views/app-views/doctors/create")),
    key: "doctors.create",
    path: `${APP_PREFIX_PATH}/doctors/create`,
  },

  // {
  //   component: React.lazy(() => import("views/app-views/doctors/update")),
  //   key: "doctors.update",
  //   path: `${APP_PREFIX_PATH}/doctors/update/:id`,
  // },
  {
    component: React.lazy(() => import("views/app-views/blogs/index.js")),
    key: "blogs",
    path: `${APP_PREFIX_PATH}/blogs`,
  },
  {
    component: React.lazy(() => import("views/app-views/account/index.js")),
    key: "admin.setting",
    path: `${APP_PREFIX_PATH}/setting`,
  },

  {
    component: React.lazy(() => import("views/app-views/admins/index")),
    key: "admins",
    path: `${APP_PREFIX_PATH}/admins`,
  },
  {
    component: React.lazy(() => import("views/app-views/admins/AdminCreate")),
    key: "admins.create",
    path: `${APP_PREFIX_PATH}/admins/create`,
  },
  {
    component: React.lazy(() => import("views/app-views/ambassadors/index")),
    key: "ambassadors",
    path: `${APP_PREFIX_PATH}/ambassadors`,
  },
  {
    component: React.lazy(() => import("views/app-views/ambassadors/AmbassadorCreate")),
    key: "ambassadors.create",
    path: `${APP_PREFIX_PATH}/ambassadors/create`,
  },
  {
    component: React.lazy(() => import("views/app-views/specialites/index")),
    key: "specialities",
    path: `${APP_PREFIX_PATH}/specialities`,
  },
  {
    component: React.lazy(
      () => import("views/app-views/specialites/add-speciality"),
    ),
    key: "specialities.create",
    path: `${APP_PREFIX_PATH}/specialities/create`,
  },
  {
    component: React.lazy(
      () => import("views/app-views/specialites/edit-speciality"),
    ),
    key: "specialities.edit",
    path: `${APP_PREFIX_PATH}/specialities/edit/:id`,
  },
  {
    component: React.lazy(() => import("views/app-views/plans/index")),
    key: "plans",
    path: `${APP_PREFIX_PATH}/plans`,
  },
  {
    component: React.lazy(() => import("views/app-views/plans/add-plan")),
    key: "plans.create",
    path: `${APP_PREFIX_PATH}/plans/create`,
  },
  {
    component: React.lazy(() => import("views/app-views/plans/edit-plan")),
    key: "plans.edit",
    path: `${APP_PREFIX_PATH}/plans/edit/:id`,
  },
];
